import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Row, Card, CardBody, CardTitle, CardSubtitle } from "reactstrap";
import { Link, withRouter, RouteComponentProps } from "react-router-dom";
import { routes } from "../../routes";
import { Activity, Box, Loader as LoaderIcon } from "react-feather";
import { IApplicationState } from "../../../redux/reducers";
import dashboardService from "../../../services/dashboardService";
import { IDashboardState } from "../../../redux/reducers/dashboardReducer";
import { IProductAnalyticsData } from "../../../interfaces/dashboard";
import AccountNotifications from "../../newDashboard/components/accountNotifications";
import Upgrade from "../../../components/common/upgrade";
import LineChart from "../../../components/charts/lineChart";
import { DataSet } from "../../../components/charts/interfaces";
import ProductActionsCard from "./ProductActionsCard";
import ProductStatCard from "./ProductStatCard";
import { INotification } from "../../../interfaces/notification";

interface IProps extends RouteComponentProps {
	profile: any;
	dashboard: IDashboardState;
	notifications: INotification[];
	fetchDashboardOverview: () => Promise<any>;
	getDashboardProductAnalytics: () => Promise<any>;
}

//TODO:
// (1) Refactor Crosshair & associated MarkSeries to prevent repeated conditional of crosshair
//     - XYPlot doesn't response well to rendering both under same <></> or <div></div> parent tag
const ProductOverview: React.FC<IProps> = (props) => {
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		setLoading(true);
		Promise.all([props.fetchDashboardOverview(), props.getDashboardProductAnalytics()]).finally(
			() => {
				setLoading(false);
			}
		);
	}, []);

	const reduceProductData = (label: string, type: string) => {
		let dataset: DataSet = {
			label: label,
			data: [],
			fill: false,
			backgroundColor: "",
			borderColor: "#fff"
		};
		props.dashboard?.product_analytics?.forEach((d: IProductAnalyticsData) => {
			dataset.data = [...dataset.data, type == "retail" ? d.retail : d.concept];
		});
		return dataset;
	};

	const calculateTrend = (data: number[]) => {
		if (data.length < 2) return 0;
		const latest = data[data.length - 1];
		const earlier = data[data.length - 2];
		if (earlier === 0) return latest > 0 ? 100 : 0;
		return Math.round(((latest - earlier) / earlier) * 100);
	};

	const activeData = (props.dashboard.product_analytics || []).map(d => d.retail);
	const conceptData = (props.dashboard.product_analytics || []).map(d => d.concept);

	const unreadNotifications = props.notifications?.filter((n: INotification) => !n.is_read && n.message_type?.toLowerCase() === "product") || [];
	const notificationsCount = unreadNotifications.length;
	// Mocking total and actions for now as they aren't explicitly in the current props but following mockup structure
	const totalActions = 10;
	const actionsPending = 0;

	return (
		<div className="product-overview mt-n3">
			<Row className="mb-4 justify-content-center">
				{/* Product Actions Card */}
				<div className="col-11 col-md-4 mb-3">
					<ProductActionsCard
						notificationsCount={notificationsCount}
						totalActions={totalActions}
						actionsPendingCount={actionsPending}
					/>
				</div>

				{/* Active Products Card */}
				<div className="col-11 col-md-4 mb-3">
					<ProductStatCard
						title="Active Products"
						count={props.dashboard.active_products_count || 0}
						comparisonText="In your catalog"
						percentageChange={calculateTrend(activeData)}
						data={activeData}
						type="active"
						loading={loading}
					/>
				</div>

				{/* Concept Products Card */}
				<div className="col-11 col-md-4 mb-3">
					<ProductStatCard
						title="Concept Products"
						count={props.dashboard.concept_products_count || 0}
						comparisonText="In development"
						percentageChange={calculateTrend(conceptData)}
						data={conceptData}
						type="concept"
						loading={loading}
					/>
				</div>
			</Row>
		</div>
	);
};

const mapStateToProps = (state: IApplicationState) => ({
	profile: state.user.profile,
	dashboard: state.dashboard,
	notifications: state.notification.all
});

const mapDispatchToProps = {
	fetchDashboardOverview: () => dashboardService.getDashboardOverview(),
	getDashboardProductAnalytics: () => dashboardService.getDashboardProductAnalytics()
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ProductOverview));
